import { VerifyCodeStepFormFieldsEnum, yupLanding } from "@ryde/utils-landings";

export const yupVerifyCodeLandingHerzliyaValidationSchema = {
  [VerifyCodeStepFormFieldsEnum.VerificationCode]: yupLanding
    .string()
    .required(),
};
